import styled from "styled-components/macro";
import {color, display} from "styled-system";
import {Body1} from "../Font";
import {WindowSizePXEnum} from "../../interface/Basic/window";

export const SelectContainer = styled.div`
  box-sizing: border-box;
  position: relative;
  width: inherit;
`

interface SelectProps {
    error?: string
}

export const SelectHeader = styled.div<SelectProps>`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  height: 40px;
  user-select: none;
  cursor: pointer;
  border-radius: 4px;
  position: relative;
  padding: 0 35px 0 12px;
  border: ${({error, theme}) => error ? theme.border.error : theme.border.default};
  background-color: ${({theme}) => theme.color.primaryBackground};
  font-size: 14px;
  line-height: 18px;
  //overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  :hover {
    border: ${({theme}) => theme.border.active};
  }


  ${Body1} {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90%;
  }

`


export const DropIconContainer = styled.div`
  position: absolute;
  right: 8px;
  height: 24px;
  width: 24px;
  display: flex;
  top: 50%;
  transform: translateY(-50%)
`

interface SelectListContainerProps {
    display?: string
}
export const SelectListContainer = styled.div<SelectListContainerProps>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  overflow: visible;
  @media(max-width: ${WindowSizePXEnum.xs}){
    ${display}
  }
`

export const SelectDownList = styled.div`
  position: absolute;
  z-index: 1000;
  border-radius: 2px;
  //min-width: fit-content;
  box-sizing: border-box;
  height: fit-content;
  max-height: 380px;
  background: ${({theme}) => theme.color.primaryBackground};
  box-shadow: 0 4px 10px rgba(105, 105, 105, 0.15), 0 2px 4px rgba(105, 105, 105, 0.25);
  padding: 12px;
`;

export const SelectListContainerLoader = styled(SelectListContainer)`
  left: 0;
  top: -8px;
  height: 100%;
  overflow: hidden;
  background: rgba(231, 232, 236, 0.3);
  //opacity: 0.5;
`

export const ListItemContainer = styled.div`
  overflow-y: auto;
  padding: 0;
  margin-left: -12px;
  margin-right: -12px;

  ::-webkit-scrollbar {
    //width: 0 !important;
  }
`;

export const ListItem = styled.div`
  cursor: pointer;
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: ${({theme}) => theme.color.primaryBackground};

  :hover {
    filter: brightness(.95);
  }

  :active {
    filter: brightness(.9);
  }

  ${color}
`;
export const ActiveListItem = styled(ListItem)`
  background-color: ${({theme}) => theme.color.secondaryBackground};
  ${color}
`;

export const SelectIconContainer = styled.div`
  position: absolute;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background-color: ${({theme}) => theme.color.primaryBackground};

  :hover {
    background-color: ${({theme}) => theme.color.secondaryBackground};
  }

  svg {
    margin: 0;
  }
`
interface MobileSelectListContainerProps {
    display? : string
}
export const MobileSelectListContainer = styled.div<MobileSelectListContainerProps>`
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  @media(max-width: ${WindowSizePXEnum.xs}){
    ${display};
    top: 56px;
    left: 0;
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 1;
    ${SelectDownList}{
      width: 100%;
      height: 100%;
      max-height: unset;
    }
  }
`






